export class MediaContent {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}
